import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../redux/ApplicationState";
import { FrequentlyAskedQuestionDispatchTypes } from "../models/dispatchTypes/Faqs";
import { GetFrequentlyAskedQuestionActionDispatchTypes } from "../constants/Faqs";
import { GetFrequentlyAskedQuestion } from "../services/Faqs";

export const getFrequentlyAskedQuestion: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    FrequentlyAskedQuestionDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetFrequentlyAskedQuestionActionDispatchTypes.GET_FREQUENTLY_ASKED_QUESTION_INVOKE,
    });
    const response = GetFrequentlyAskedQuestion();
    dispatch({
      response: response,
      type: GetFrequentlyAskedQuestionActionDispatchTypes.GET_FREQUENTLY_ASKED_QUESTION_SUCCESS,
    });
  };
};
